import "./time.css";
import React, { Children, useEffect, useState } from "react";
import refresh from "../../../dashboardicon/refreshIcon.svg";
import Button from "../Button";
import CustomModal from "../Modal/modal";
import QRCode from "react-qr-code";
import BarcodeReader from "react-barcode-reader";
import TextAreaField from "../textarea";
import tick from "../../../dashboardicon/tick.svg"
const StaticCard = ({ position, digit }) => {
  return (
    <div className={position}>
      <span>{digit}</span>
    </div>
  );
};

const FlipUnitContainer = ({ digit, unit }) => {
  return (
    <>
      <div className={"flipUnitContainer"}>
        <StaticCard position={"upperCard"} digit={digit} />
        <StaticCard position={"lowerCard"} digit={digit} />
        <p>{unit}</p>
      </div>
    </>
  );
};

const FlipClock = ({ hours, days, minutes, seconds }) => {
  console.log(minutes);
  return (
    <>
      <div className={"flipClock"}>
        <FlipUnitContainer unit={"days"} digit={days} />
        <span
          style={{
            marginTop: "17px",
            fontSize: "23px",
            fontWeight: "800",
            color: "rgb(165 146 142)",
          }}
        >
          :
        </span>
        <FlipUnitContainer unit={"hours"} digit={hours} />
        <span
          style={{
            marginTop: "17px",
            fontSize: "23px",
            fontWeight: "800",
            color: "rgb(165 146 142)",
          }}
        >
          :
        </span>
        <FlipUnitContainer unit={"minutes"} digit={minutes} />
        <span
          style={{
            marginTop: "17px",
            fontSize: "23px",
            fontWeight: "800",
            color: "rgb(165 146 142)",
          }}
        >
          :
        </span>
        <FlipUnitContainer unit={"seconds"} digit={seconds} />
      </div>
    </>
  );
};

const WorkingFlipDate = ({
  hours,
  minutes,
  seconds,
  days,
  image,
  imagePath,
  imageClass,
  messageClass,
  message,
  children,
  disable,
  refreshDate,
  scanning
}) => {
  const [showModal,setShowModal] = useState(false)
  const [scanData , setScanData] = useState("")
  const [missingChar,setmissingChar]= useState(null)
  const dummyScanChar = "A B C D E F G H I J K L M N O P Q R S T U V W X Y Z # 0 1 2 3 4 5 6 7 8 9 . abcdefghijklmnopqrstuvwxyz - _ @ $ , :"
  console.log(minutes);

  const onClose = () =>{
    setShowModal(false)
    setScanData("")
  }

  const handleError = (err) => {
    console.error(err);
  };

  const handleScan = (data) => {
    console.log(scanData)
      setScanData(data);
  };

  useEffect(()=>{
    if(scanData!=""){
      setmissingChar(second(dummyScanChar, scanData))
    }
  },[scanData])
  const handleChange = (key, value) => {
    // setData((prevState) => ({
    //   ...prevState,
    //   [key]: value,
    // }));
  };
  
console.log(missingChar)

function second(str1,str2) {
  // return Array.prototype.filter.call(str1, function(c) {
  //     return str2.indexOf(c) === -1;
  // }, this).join('');
  if (str1.length !== str2.length) {
    return "No";
  }
  // Compare each character one by one
  for (let i = 0; i < str1.length; i++) {
    if (str1[i] !== str2[i]) {
      return "No"
    }
  }
  // If all characters match exactly
  return "";
}

  return (
    <>
      <CustomModal
        className="custom_modal confirm-modal"
        show={showModal}
        onClose={onClose}
        size="55%"
        closeIcon={true}
        // modalTitle={props.localLang?.CONFIRMATION_POPUP?.TITLE}
        children={
     <>
     <p style={{
      fontSize: "17px",
      color: "red",
      fontWeight: "500",
      fontFamily: "auto",
     }}>Kindly scan this Qr code with scanner and make sure all alphabets(A - Z), Numbers(0 - 9) and Special Characters( # ) are scannable. i.e-   A B C D E F G H I J K L M N O P Q R S T U V W X Y Z # 0 1 2 3 4 5 6 7 8 9 . abcdefghijklmnopqrstuvwxyz - _ @ $ , : </p>
     <div style={{ height: "auto", margin: "0 auto", maxWidth: "100Px", width: "100%" }}>
    <QRCode
    size={350}
    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
    value={dummyScanChar}
    viewBox={`0 0 350 350`}
    />
   
</div>
<div className="col-md-12 my-4 d-flex" >
    <TextAreaField
    inputClass={"col-md-12"}
    labelClass={"col-md-12"}
    readonly={true}
              type="textrea"
              name="remarks"
              placeholder=""
              rows="4"
              cols="400"
              maxLength="250"
              value={scanData}
              onChange={(val) => handleChange("remarks", val)}
            ></TextAreaField>
          {missingChar === "" &&   <img className="ballotcheckOk" src={tick} />}
    </div>
    {(missingChar !=null && missingChar !=="") && <div className="col-md-12 my-4 ">
      <h6 style={{ color:"red", textAlign:"center"}}> The QR Code scanner is not compatible. Please try to reset the QR Code Scanner to factory mode and manual trigger mode and re-check its compatibility, else replace the QR Code Scanner.</h6>
    </div>}
     </>
        }
      />
      {disable  ? (
<>
{scanning && <>
  <BarcodeReader onError={handleError} onScan={handleScan} />
  <div class="marquee">
  <div class="marquee__group">
        <div class="flexx items-center">
      <span>★★ Note - Please ensure to test your Qr code scanner before starting the Pre-Counting scanning </span></div>
      <div class="flexx items-center">
      <span>★★ Note - Please ensure to test your Qr code scanner before starting the Pre-Counting scanning </span></div>
      <div class="flexx items-center">
      <span>★★ Note - Please ensure to test your Qr code scanner before starting the Pre-Counting scanning </span></div>
   </div>
</div>
<div className="row" style={{display:"flex",justifyContent:"end",width:"90%",margin:"1% 10%"}}>
<a onClick={()=>{setShowModal(true)}} className="clickHere">
Click here to Test Your Qr Scanner
</a>
</div>
</>}
        <div
          className="row"
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            marginTop: "12%",
          }}
        >
     
          <div style={{ display: "flex" }}>
            <FlipClock
              days={days}
              hours={hours}
              minutes={minutes}
              seconds={seconds}
            />
            <div style={{ display: "flex", width: "100px" }}>
              <img
                src={refresh}
                alt="ico"
                style={{
                  width: "30px",
                  height: "30px",
                  marginLeft: "auto",
                  marginTop: "24px",
                  cursor: "pointer",
                }}
                onClick={refreshDate}
              ></img>
            </div>
          </div>
          <div className="row">
            <p className={messageClass}>{message}</p>
          </div>
          {image && imagePath != "" && (
            <img alt="My Image" className={imageClass} src={imagePath} />
          )}
        </div>
</>
      ) : (
        children
      )}
    </>
  );
};

export default WorkingFlipDate;
